import { useCallback, useEffect, useState } from 'react';
import { crmApi } from '../../api.js';
import type { FilialZustand } from './crm-felder.js';

/** #851 Filialliste für die Auswahl der Stammfiliale (Anlegen und Bearbeiten); `erneut` lädt nach einem Fehler neu */
export function useFilialen(aktiv = true): { zustand: FilialZustand; erneut: () => void } {
  const [zustand, setZustand] = useState<FilialZustand>({ kind: 'laden' });
  const [lauf, setLauf] = useState(0);
  useEffect(() => {
    if (!aktiv) return;
    let gueltig = true;
    setZustand({ kind: 'laden' });
    crmApi.filialen().then(
      (filialen) => gueltig && setZustand({ kind: 'ok', filialen }),
      () => gueltig && setZustand({ kind: 'fehler' }),
    );
    return () => {
      gueltig = false;
    };
  }, [aktiv, lauf]);
  const erneut = useCallback(() => setLauf((n) => n + 1), []);
  return { zustand, erneut };
}
